module.exports = __webpack_public_path__ + "assets/img/本地生活铂金会员@2x.e158a8f4.png";